<template>
	<core-modal
		:name="`${this.integration.id}-integrations-delete-modal`"
		class="omapi-modal bulk-delete-modal"
		:isConfirmation="true"
	>
		<modals-content>
			<common-transition-slide :active="showAlert">
				<core-alert :type="alertType">
					<div class="alert-message">
						{{ alertMessage }}
					</div>
				</core-alert>
			</common-transition-slide>
			<form @submit.prevent="handleDelete">
				<p>
					Are you sure you want to permanently disconnect the integration:<br>
					<strong>{{ integration.label }}</strong>
				</p>
				<p>
					Any campaigns using this integration will also be disconnected, and should be updated with a new integration to ensure proper functionality.
				</p>

				<section class="buttons">
					<core-loading-button
						class="delete-integration"
						size="large"
						color="blue"
						buttonType="submit"
					>
						<svg-loading v-if="isDeleting" class="loading-button-spinner"/>
						<span v-else>Yes, I'm Sure</span>
					</core-loading-button>
					<button
						class="omapi-button omapi-button__white omapi-button__large"
						@click.prevent="handleClose"
					>
						Cancel
					</button>
				</section>
			</form>
		</modals-content>
	</core-modal>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'
const { mapActions, mapState } = createNamespacedHelpers('integrations')

export default {
	data () {
		return {
			alertMessage : '',
			alertType    : 'info',
		}
	},
	props : {
		integration : {
			type     : Object,
			required : true,
		},
	},
	computed : {
		...mapState([ 'isDeleting' ]),
		/**
		 * Show Alert
		 *
		 * @since 2.4.0
		 *
		 * @returns {boolean} Should the alert be shown?
		 */
		showAlert () {
			return !this.isDeleting && '' !== this.alertMessage
		},
	},
	methods : {
		...mapActions([ 'deleteIntegration' ]),
		/**
		 * Handle Close
		 *
		 * @since 2.4.0
		 *
		 * @returns {void}
		 */
		handleClose () {
			this.$modal.hide(`${this.integration.id}-integrations-delete-modal`)
		},
		/**
		 * Handle Delete
		 *
		 * @since 2.4.0
		 *
		 * @returns {void}
		 */
		handleDelete () {
			this.deleteIntegration(this.integration)
				.then(() => {
					this.handleClose()
				})
				.catch(error => {
					this.alertType = 'error'
					this.alertMessage = error.response.body.message || 'Integration could not be deleted.'
				})
		},
	},
}
</script>
